<template>
  <div id="gsxx">
    <p><b>公司名称：</b> {{gsxx.GSMC}} </p>
    <p><b>许可证号：</b> {{gsxx.XKZH}} </p>
    <p><b>经营范围：</b> {{gsxx.JYFW}} </p>
    <p><b>金融期货业务资格类别：</b> {{gsxx.ZGLB}} </p>
    <p><b>取得会员资格的期货交易所名称：</b> {{gsxx.QDZG}} </p>
    <p><b>注册资本：</b> {{gsxx.ZCZB}} </p>
    <p><b>公司住所：</b> {{gsxx.GSZS}} </p>
    <p><b>法定代表人：</b> {{gsxx.FR}} </p>
    <p><b>办公地址和邮编：</b> {{gsxx.BGDZ}} </p>
    <p><b>客户服务及投诉电话：</b><br/> {{gsxx.TSDH}} </p>
    <p><b>公司网址：</b> {{gsxx.GSWZ}} </p>
    <p><b>公司电子邮箱：</b> {{gsxx.DZYX}} </p>
    <div class="margin-b"></div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'

  export default {

    name: 'gsxx',
    data () {
      return {
        gsxx: {}
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        ajax.getGSXX().then(
          data => {
            this.gsxx = data[0]
          }
        )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// gsxx.vue?0618a0f6